import { createAction } from '@reduxjs/toolkit';
import EcomEngineAPI from 'api/ecom_engine_api';
import { trackError } from 'utils/helpers';

export const fetchFamiliesStarted = createAction(
  'vehicleLink/fetchFamiliesStarted'
);
export const fetchFamiliesSucceeded = createAction(
  'vehicleLink/fetchFamiliesSucceeded'
);
export const fetchFamiliesFailed = createAction(
  'vehicleLink/fetchFamiliesFailed'
);
export const setFamilies = createAction('vehicleLink/setFamilies');

export const fetchFamilies = (params) => (dispatch, getState) => {
  const cacheKeyName = `${params.code}_${params.makeCode}`;
  const existingFamilies = getState().vehicleLink.families[cacheKeyName];

  if (existingFamilies) {
    return existingFamilies;
  }

  dispatch(fetchFamiliesStarted());

  return EcomEngineAPI.vehicleLink
    .families(params)
    .then((families) => {
      dispatch(fetchFamiliesSucceeded());
      dispatch(
        setFamilies({
          cacheKeyName,
          families,
        })
      );
    })
    .catch((error) => {
      trackError(error);
      dispatch(fetchFamiliesFailed(error.message));
    });
};
